<template>
  <d-modal
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header>
      <template v-if="editMode">Edycja spotkania</template>
      <template v-else>Dodawanie spotkania</template>
    </d-modal-header>
    <d-modal-body>
      <!-- Form -->
      <d-form>
        <d-container class="pl-0 pr-0">
          <validation-observer
            ref="meeting-form"
            tag="form">

            <div class="form-group">
              <label for="customer">
                Klient:
              </label>
              <validation-provider
                rules="required"
                name="customer"
                v-slot="{ errors }">
                <div
                  :class="{
                    'form-control': true,
                    'is-select': true,
                    'is-invalid': errors.length,
                    'vs-wrap-text': true
                  }">
                  <v-select
                    v-model="selectedCustomer"
                    :filter="filterCustomers"
                    :options="limitedCustomers"
                    :searchable="true"
                    placeholder="Wybierz klienta"
                    ref="customers-filter"
                    label="name">
                    <template slot="no-options">
                      <template v-if="!customersEmptyResults">Trwa wyszukiwanie&hellip;</template>
                      <template v-else>Brak klientów pasujących do podanej frazy&hellip;</template>
                    </template>
                    <template
                      slot="option"
                      slot-scope="option">
                      <div class="d-center">
                         {{ option.invoice_company }}
                      </div>
                    </template>
                    <template
                      slot="selected-option"
                      slot-scope="option">
                      <div class="selected d-center">
                         {{ option.invoice_company }}
                      </div>
                    </template>
                  </v-select>
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="dateRange">
                Data:
              </label>

              <validation-provider
                rules="required"
                name="dateRange"
                v-slot="{ errors }">
                <date-range-picker
                  v-if="dateRangePickerVisible"
                  ref="picker"
                  :locale-data="{
                    'firstDay': 1,
                    'format': 'DD-MM-YYYY',
                    'daysOfWeek': ['Ndz', 'Pon', 'Wto', 'Śro', 'Czw', 'Ptk', 'Sob'],
                    'monthNames': ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
                    'applyLabel': 'OK',
                    'cancelLabel': 'Anuluj'
                  }"
                  class="mr-1 mb-2"
                  :singleDatePicker="true"
                  :timePicker="true"
                  :showWeekNumbers="false"
                  :showDropdowns="false"
                  v-model="dateRange"
                  :ranges="false"
                  :linkedCalendars="true"
                  :date-format="dateFormat">
                  <template v-slot:input="picker" style="min-width: 350px; max-width: 50%;">
                    {{ picker.startDate | formatDate }}
                  </template>
                </date-range-picker>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>


            <div class="form-group">
              <label for="important_information">
                Ważne informacje:
              </label>

              <validation-provider
                name="important_information"
                v-slot="{ errors }">
                <d-textarea
                    :state="errors.length ? 'invalid' : null"
                    v-model="important_information"
                    :value.prop="important_information"
                    :rows="6"/>
                <div class="invalid-feedback">
                    {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div class="form-group">
              <label for="description">
                Notatka:
              </label>

              <validation-provider
                name="description"
                v-slot="{ errors }">
                <d-textarea
                    :state="errors.length ? 'invalid' : null"
                    v-model="description"
                    :value.prop="description"
                    :rows="6"/>
                <div class="invalid-feedback">
                    {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </validation-observer>
        </d-container>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        Anuluj
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="submitInProgress"
        @click.prevent="validateForm">
        <div
          v-if="submitInProgress"
          class="spinner-border spinner-border-sm"
          role="status">
        </div>
        <template v-if="editMode">Zapisz zmiany</template>
        <template v-else>Dodaj</template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>
<script>
import Vue from 'vue';
import FormUtils from './../../utils/FormUtils.js';
import DateRangePicker from 'vue2-daterange-picker';

export default {
  name: 'meeting-form',
  components: {
    'date-range-picker': DateRangePicker
  },
  props: [
    'allCustomers'
  ],
  filters: {
    formatDate (input) {
      if (!input) {
        return 'Wybierz datę';
      }

      let dateObject = new Date(input);

      return [
        dateObject.getFullYear(),
        dateObject.getMonth() + 1,
        dateObject.getDate()
      ]
        .map(n => n < 10 ? '0' + n : n)
        .join('-') + ' ' + [
        dateObject.getHours(),
        dateObject.getMinutes()
      ]
        .map(n => n < 10 ? '0' + n : n)
        .join(':');
    },
  },
  computed: {
    limitedCustomers () {
      let options = this.allCustomers;

      if (this.$refs['customers-filter'] && this.$refs['customers-filter'].search.length < 1) {
        return options.slice(0, 100);
      }

      return options;
    }
  },
  watch: {
    'dateRange.startDate': function (newValue) {
      if (newValue === null) {
        this.date = null;
        this.time = null;
      }

      this.time = this.prepareTimeString(newValue);
      this.date = this.prepareDateString(newValue);
    },
    selectedCustomer (newValue) {
      if (newValue && newValue.id) {
        this.customer_id = newValue.id;
        return
      }

      this.customer_id = null;
    }
  },
  data() {
    return {
      id: null,
      customer_id: null,
      selectedCustomer: null,
      date: null,
      time: null,
      important_information: '',
      description: '',
      isHidden: true,
      submitInProgress: false,
      editMode: false,
      customersEmptyResults: false,
      dateRange: {
        startDate: null,
        endDate: null
      },
      dateRangePickerVisible: false
    };
  },
  mounted() {
    this.$bus.$on('calendar-add-meeting-popup-show', this.openPopup);
  },
  methods: {
    handleClose() {
      this.isHidden = true;
    },
    validateForm() {
      FormUtils.validate(this.$refs['meeting-form'], this.save);
    },
    save () {
      this.submitInProgress = true;
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.editMode ? '/api/meetings/update/' + this.id : '/api/meetings/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano spotkanie',
        successText: 'Wybrane spotkanie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja spotkania nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.submitInProgress = false;
          this.$bus.$emit('calendar-refresh');
          this.handleClose();
        },
        failAction: () => {
          this.submitInProgress = false;
        },
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        date: this.date,
        time: this.time,
        customer_id: this.customer_id,
        important_information: this.important_information,
        description: this.description
      };

      return formDataToSend;
    },
    openPopup(meeting = null, defaultDate = null) {
      this.editMode = !!meeting;

      if (this.editMode) {
        this.id = meeting.id;
        this.customer_id = meeting.customer_id;
        this.date = meeting.date;
        this.time = meeting.time;
        this.description = meeting.description;
        this.important_information = meeting.important_information;
        this.dateRangePickerVisible = false;

        Vue.nextTick(() => {
          Vue.set(this.dateRange, 'startDate', new Date(meeting.date + ' ' + meeting.time));
          this.dateRangePickerVisible = true;
        });
      } else {
        let currentDate = new Date();

        if (defaultDate) {
          currentDate = new Date(defaultDate);
        }

        this.date = this.prepareDateString(currentDate);
        this.id = null;
        this.customer_id = null;
        this.time = this.prepareTimeString(currentDate);
        this.description = '';
        this.important_information = '';
        this.dateRangePickerVisible = false;

        Vue.nextTick(() => {
          Vue.set(this.dateRange, 'startDate', currentDate);
          this.dateRangePickerVisible = true;
        });
      }

      setTimeout(() => {
        this.isHidden = false;
        if (this.$refs['meeting-form']) {
          this.$refs['meeting-form'].reset();
        }
      }, 0);
    },
    cancel() {
      this.handleClose();
    },
    prepareDateString (input) {
      if (input === null) {
        return null;
      }
      return [
        input.getFullYear(),
        input.getMonth() + 1,
        input.getDate()
      ]
        .map(n => n < 10 ? '0' + n : n)
        .join('-');
    },
    prepareTimeString (input) {
      if (input === null) {
        return null;
      }
      return [
        input.getHours(),
        input.getMinutes()
      ]
        .map(n => n < 10 ? '0' + n : n)
        .join(':');
    },
    dateFormat (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date()
      }
      return classes
    },
    filterCustomers (options, search) {
      let results = options.filter(item => (item.invoice_company).toLocaleLowerCase('pl').indexOf(search.toLocaleLowerCase('pl')) > -1).slice(0, 100);
      if (results.length) {
        this.customersEmptyResults = false;
      } else {
        this.customersEmptyResults = true;
      }
      return results;
    },
  },
  beforeDestroy () {
    this.$bus.$off('calendar-add-meeting-popup-show', this.openPopup);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}

.vue-daterange-picker {
  width: 100%;
}
</style>
